import React, { useState, useEffect } from "react";
import { useTheme } from "../ThemeProvider";
import { displayPhotoUrl } from "@/lib/photo";

const AVATAR_COLORS = [
  "#007BFF", "#28A745", "#FF8C00", "#8A2BE2", "#E91E8C",
  "#17A2B8", "#FFC107", "#6C757D", "#DC3545", "#20C997",
];

const SELISE_COLORS = [
  "#1e3a8a", "#1e40af", "#2563eb", "#3b82f6", "#60a5fa",
  "#1e293b", "#334155", "#475569", "#64748b", "#94a3b8",
];

function getInitials(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}

function getColor(name, palette) {
  const hash = name.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return palette[hash % palette.length];
}

export default function Avatar({ name, photoUrl, size = "sm" }) {
  const { theme } = useTheme();
  const [failed, setFailed] = useState(false);
  // Reset the failure flag when the photo changes (e.g. after a new upload).
  useEffect(() => setFailed(false), [photoUrl]);

  const palette = theme === "selise" || theme === "dark" ? SELISE_COLORS : AVATAR_COLORS;
  const sizeClass =
    size === "xs" ? "w-6 h-6 text-[10px]" : size === "sm" ? "w-8 h-8 text-xs" : size === "md" ? "w-10 h-10 text-sm" : "w-14 h-14 text-base";

  // Only Blocks-storage (non-base44) images; anything else falls back to initials.
  const src = failed ? null : displayPhotoUrl(photoUrl);

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => setFailed(true)}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0`}
        style={{ boxShadow: "0 4px 6px -1px rgba(0,0,0,0.25), 0 2px 4px -1px rgba(0,0,0,0.18)" }}
      />
    );
  }
  return (
    <div
      className={`${sizeClass} rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0`}
      style={{ backgroundColor: getColor(name || "?", palette), boxShadow: "0 4px 6px -1px rgba(0,0,0,0.25), 0 2px 4px -1px rgba(0,0,0,0.18)" }}
    >
      {getInitials(name || "?")}
    </div>
  );
}